import { action, computed, makeAutoObservable, runInAction } from "mobx"
import moment from "moment";
import { PaymentProviderType } from "../../../../../services/general/models";
import { ExecutionStatus } from "../../../../../services/general/requestsResponses"
import { getOrder, getOrders, returnPayment } from "../../../../../services/orders";
import { Order, OrderStatus } from "../../../../../services/orders/models";
import { GetOrderRequest } from "../../../../../services/orders/requestsResponses";
import { DeliveryType, Menu } from "../../../../../services/menu/models";
import { getMenus } from "../../../../../services/menu";



interface IOrdersFilter{
    createdAfter: Date;
    createdBefore: Date;
    deliveryTypes: DeliveryType[];
    isPaid: boolean | null;
    paymentTypes: PaymentProviderType[];
    statuses: OrderStatus[];
    limit: number;
    skip: number;
    menusIds: number[],
    clientsIds: number[]
}

class OrdersStore {

    ordersList: Order [] = [];
    isLoaded: boolean = false;
    currentOrder?: Order;
    menusList: Menu[] = [];

    showDetailsForm: {
            currentOrder?: Order,
            isFormOpen: boolean
        } = {
            isFormOpen: false
            };

    filter:IOrdersFilter  = {
        createdAfter: moment().startOf("day").toDate(),
        createdBefore: moment().endOf("day").toDate(),
        deliveryTypes: [
            DeliveryType.takeaway,
            DeliveryType.takeAwayToTime,
            DeliveryType.toAddress,
            DeliveryType.toTable,
            DeliveryType.toVehicle,
            DeliveryType.insideTheRestaurant
        ],
        isPaid: null,
        paymentTypes: [
            PaymentProviderType.cloudpayments,
            PaymentProviderType.companyInvoice,
            PaymentProviderType.offline,
            PaymentProviderType.toBankCard,
            PaymentProviderType.sbpTochka
        ],
        statuses: [
            OrderStatus.paid,
            OrderStatus.accepted,
            OrderStatus.acceptedByKitchen,
            OrderStatus.canceled,
            OrderStatus.canceledWithRefund,
            OrderStatus.canceledByKitchen,
            OrderStatus.finished,
            OrderStatus.givenOut,
            OrderStatus.givenOutToDelivery,
            OrderStatus.new,
            OrderStatus.ready,
            OrderStatus.readyToPickUp,
            OrderStatus.sentToKitchen,
        ],
        limit: 200,
        skip: 0,
        menusIds: [],
        clientsIds: []
    }

    constructor() {
        makeAutoObservable(this)
    }



    async init() {
        const menusResponse = await getMenus();
        runInAction(() => {
            this.menusList = menusResponse.menus;
            if (this.menusList.length !== 0 && this.filter.menusIds.length === 0) {
                this.filter.menusIds = [this.menusList[0].id];
            }
        });
    }

    getMenuById(menuId: number): Menu | undefined{
        return this.menusList.find(item => item.id === menuId);
    }

    async getOrders(data) {
        const getOrdersResponse = await getOrders(data);
        runInAction(() => {
          this.ordersList = getOrdersResponse.orders;
          this.isLoaded = true;
        });
      }

      async getOrder(data: GetOrderRequest) {
        const getOrderResponse = await getOrder(data);
        runInAction(() => {
          this.currentOrder = getOrderResponse.order;
          this.isLoaded = true;
        });
      }

      async returnPayment(data) {
        const res = await returnPayment(data);
        runInAction(() => {
            if (this.currentOrder) {
                this.currentOrder.paymentDetails.isPaid = false;
            }
        });
        return res.executionStatus === ExecutionStatus.Finished;

    }

      async ensureOrdersLoaded(filter: IOrdersFilter){
        if(!this.isLoaded){
            const response = await getOrders(filter);
            runInAction(() => {
                this.filter = filter;
                this.ordersList = response.orders
                this.isLoaded = true;
            })
        }
    }


    async reloadOrders(){
        runInAction(() => {
            this.isLoaded = false;
        })
        await this.ensureOrdersLoaded(this.filter);
    }



    @action
    openForm(current?: Order){
        this.showDetailsForm.isFormOpen = true;
        this.showDetailsForm.currentOrder = current;
    }

    @action
    closeForm(){
        this.showDetailsForm.isFormOpen = false;
        this.showDetailsForm.currentOrder = undefined;
    }

    @action
    setOrdersFilter(filter: IOrdersFilter) {
        this.filter = filter;
    }

    @computed
    getOrderById(orderId: number) {
        return this.ordersList.find(item => item.id === orderId);
    }

}


export default OrdersStore
